/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationResult { 
    /**
     * Id Hash. UAI (Unique Application Identifier)
     */
    idHash?: string;
    /**
     * Name
     */
    name?: string;
    /**
     * Commercial Name
     */
    commercialName?: string;
    /**
     * Nif
     */
    nif?: string;
    /**
     * Link
     */
    link?: string;
    /**
     * Type
     */
    type?: string;
    /**
     * Logo. Encoded in Base64 format
     */
    logo?: ApplicationResult.LogoEnum;
}
export namespace ApplicationResult {
    export const LogoEnum = {
        B57c47a9e: '[B@57c47a9e'
    } as const;
    export type LogoEnum = typeof LogoEnum[keyof typeof LogoEnum];
}


